import React from 'react';
import styled from 'styled-components'

import higherAOV from '../../images/higher-aov.svg'
import higherConversions from '../../images/higher-conversions.svg'
import moreSubscriptions from '../../images/more-conversions.svg'
import betterSalesEvents from '../../images/better-sales-event.svg'
import betterAffiliates from '../../images/better-affiliates.svg'

const ECOMPricingContainer = styled.section`
  padding: 104px 0 120px;
  background-color: #5538ff;
  margin: 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  &::before {
    background: radial-gradient(
      circle at 25% 50%,
      rgba(153, 78, 255, 1) 0%,
      transparent 50%
    );
  }

  &::after {
    background: radial-gradient(
      circle at bottom 20% right 20%,
      rgba(255, 141, 56, 0.5) 0%,
      transparent 40%
    );
  }

  .container {
    height: 100%;
    position: relative;
    z-index: 2;
    text-align: center;
  }

  h2 {
    text-align: center;
    color: #fff;
    margin-bottom: 72px;
  }

  .row {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 24px;
  }

  .pricingContainer {
    padding: 64px 48px;
    margin: 0 24px;
    background: rgba(250, 248, 255, 0.11);
    box-shadow: 0 11px 20px 0 rgba(0, 0, 0, 0.09);
    max-width: 454px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .pricingHead {
      text-align: center;

      h3 {
        font-size: 26px;
        line-height: 33px;
        color: white;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 2px;
        margin-bottom: 32px;
        margin: 0 0 8px;
      }

      h3 + span {
        font-size: 20px;
        line-height: 26px;
        color: #e7e2fe;
      }

      .price {
        min-height: 76px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin: 40px 0;

        p {
          font-size: 18px;
          line-height: 1;
          color: #e7e2fe;
          margin: 0 0 8px;

          &.notice {
            font-size: 24px;
            font-weight: 500;
            line-height: 1;
            color: #fff;
          }
        }

        h4 {
          font-size: 46px;
          line-height: 1;
          color: #fff;
          font-weight: 500;
          margin: 0;

          span {
            font-weight: normal;
            font-size: 20px;
            margin-left: -4px;
          }
        }
      }
    }

    .pricingOffers {
      margin: 0 auto;
      padding: 0;
      list-style: none;

      li {
        padding: 0 0 0 32px;
        position: relative;
        font-size: 20px;
        line-height: 26px;
        text-align: left;

        &::before {
          content: "";
          background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM8 15.414L3.293 10.707L4.707 9.293L8 12.586L15.293 5.293L16.707 6.707L8 15.414Z' fill='white'/%3E%3C/svg%3E%0A");
          background-repeat: no-repeat;
          width: 20px;
          height: 20px;
          position: absolute;
          top: calc(50% - 10px);
          left: 0;
        }

        & + li {
          margin-top: 16px;
        }
      }
    }

    @media (max-width: 768px) {
      padding: 32px;
      margin: 0 auto;

      & + .pricingContainer{
        margin-top: 24px;
      }

      .pricingHead {
        width: 100%;
        margin-bottom: 24px;

        h3 {
          font-size: 18px;
          line-height: 26px;
          letter-spacing: 1.69px;
          margin-bottom: 0;

          br{
            display: none;
          }
        }

        .price {
          min-height: auto;
          margin: 24px 0 32px;

          p {
            font-size: 18px;
            line-height: 1;
            color: #e7e2fe;
            margin: 0 0 8px;

            &.notice {
              font-size: 24px;
              font-weight: 500;
              line-height: 1;
              color: #fff;
            }
          }

          h4 {
            font-size: 46px;
            line-height: 1;
            color: #fff;
            font-weight: 500;
            margin: 0;

            span {
              font-weight: normal;
              font-size: 20px;
              margin-left: -4px;
            }
          }
        }
      }

      .pricingOffers {
        margin: 0 auto;

        li {
          padding: 0 0 0 30px;
          font-size: 16px;
          line-height: 22px;

          &::before {
            content: "";
            background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 0C4.0293 0 0 4.0293 0 9C0 13.9707 4.0293 18 9 18C13.9707 18 18 13.9707 18 9C18 4.0293 13.9707 0 9 0ZM7.2 13.8726L2.9637 9.6363L4.2363 8.3637L7.2 11.3274L13.7637 4.7637L15.0363 6.0363L7.2 13.8726Z' fill='white'/%3E%3C/svg%3E%0A");
            width: 18px;
            height: 18px;
            top: calc(50% - 9px);
          }

          & + li {
            margin-top: 8px;
          }
        }
      }
    }
  }

  .btn {
    display: inline-flex;
    padding: 21px 56px 25px;
    background: #131217;
    color: #fff;
    font-size: 22px;
    line-height: 1.2;
    font-weight: 500;
    text-decoration: none;
    position: relative;
    transition: all 0.2s ease-in-out;
    margin: 48px 0 0 0;

    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      border: 2px solid #000;
      transition: all 0.15s ease-in-out;
      transform: translate(8px, 8px);
    }

    &:hover {
      background: #fff;
      color: #000;

      &:before {
        transform: translate(0, 0);
      }
    }

    @media screen and (max-width: 768px) {
      padding: 19px 56px 21px;
      font-size: 18px;
      width: 100%;
      justify-content: center;
    }
  }

  ul{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 788px;
    margin: 64px auto 0;
    padding: 0;

    li{
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        & + li{
            margin-left: 48px;
        }

        span{
            font-size: 24px;
            font-weight: 500;

            &.icon{
                margin-right: 12px;
            }
        }

    }
  }

  @media (max-width: 824px) {
    ul{
      margin: 80px 0 0;

      li{
          margin: 0 32px 32px;

          & + li{
              margin-left: 32px;
          }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 64px 0 72px;
    
    h2 {
      margin-bottom: 48px;
      padding: 0 24px;
    }
    
    .row {
      flex-direction: column;
      margin-bottom: 0;
    }
  }
  @media (max-width: 600px) {
    ul{
      flex-direction: column;
      align-items: flext-start;
      margin: 64px 0 0;

      li{
        margin: 0;
        margin-bottom: 24px;

        & + li{
            margin-left: 0;
        }

        &:last-child{
            margin-bottom: 0;
        }

        span{
            font-size: 18px;
            line-height: 20px;

            &.icon{
                margin-right: 12px;
                width: 34px;
            }
        }
      }
    }
  }
`

const ECOMPricing = (props) => {
    return (
      <ECOMPricingContainer id="pricing">
        <div className="container">
          <h2>Pricing</h2>

          <div className="row">
            <div className="pricingContainer">
              <div className="pricingHead">
                <h3>Ecommerce Upgrade</h3>
              </div>

              <p>Full ecommerce upgrade&mdash;including copy, design, code and advanced growth tactics—to take your store to the next level.</p>
            </div>
            <div className="pricingContainer">
              <div className="pricingHead">
                <h3>Ondemand Web Team</h3>
              </div>

              <p>Tap into our web team whenever you need us&mdash;copy writing, design, code, marketing automation, and more.</p>
            </div>
          </div>

          <a href="https://form.typeform.com/to/lf6sAz4T" target="_blank" rel="noreferrer" className="btn">Contact Us</a>

          <ul>
              <li><span className="icon"><img src={higherAOV} alt=""/></span><span>Higher AOV</span></li>
              <li><span className="icon"><img src={higherConversions} alt=""/></span><span>Higher Conversions</span></li>
              <li><span className="icon"><img src={moreSubscriptions} alt=""/></span><span>More Subscriptions</span></li>
              <li><span className="icon"><img src={betterSalesEvents} alt=""/></span><span>Better Sales Events</span></li>
              <li><span className="icon"><img src={betterAffiliates} alt=""/></span><span>Better Performing Affiliates</span></li>
          </ul>
        </div>
      </ECOMPricingContainer>
    )
}

export default ECOMPricing